import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TablePagination,
  Chip,
  TableFooter,
  CircularProgress
} from "@mui/material";
import axiosInstance from "../../utilities/Axios";
import AlertDialog from "../AlertDialog/AlertDialog";
import CountryProcessDialogBox from "./CountryProcessDialogBox";
import { EDialogAction } from "../Enum/DialogActionEnum";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../Hooks/ThemeContext/ThemeContext";
import { DeleteOutline, EditOutlined, OpenInNew, SendOutlined } from "@mui/icons-material";
import { LoadingStateContext } from "../../Hooks/LoadingContext/LoadingContext";

const CountryProcessTableTable = (props: { filter: any }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [countryProcess, setCountryProcess] = useState(null);
  const [countryProcessList, setCountryProcessList] = useState<any[]>([]);
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [editDialogVisibility, setEditDialogVisibility] = useState(false);
  const [alertDialogVisibility, setAlertDialogVisibility] = useState(false);
  const [dialogAction, setDialogAction] = useState(EDialogAction.view);
  let [filter, setFilter] = useState<any>({});
  const { changeLoading, isLoading } = React.useContext(LoadingStateContext);
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    getCountryProcessList();
  }, [page, limit, props.filter]);

  const getCountryProcessList = async () => {
    changeLoading(true);
    try {
      const response = await axiosInstance.get(
        `/v1/country-process?type=${theme.theme}&page=${page}&items_per_page=${limit}`,
        {
          params: props.filter,
        }
      );

      const data = response.data;
      setCountryProcessList(data.result.data);

      setTotalItems(data.result.total);
    } catch (err) {
      console.log(err);
    } finally {
      changeLoading(false);
    }
  };

  const getCountryProcessById = async (
    countryProcessId: number,
    action: EDialogAction
  ) => {
    try {
      const response = await axiosInstance.get(
        `/v1/country-process/${countryProcessId}`,
        {}
      );

      const data = response.data;
      setCountryProcess(data.result);

      if (action == EDialogAction.edit) {
        setEditDialogVisibility(true);
      } else if (action == EDialogAction.view) {
        setEditDialogVisibility(true);
      } else if (action == EDialogAction.delete) {
        setAlertDialogVisibility(true);
      }
      setDialogAction(action);
    } catch (err) {
      console.log(err);
    }
  };

  const goToNextPage = () => {
    setPage(page + 1);
  };

  const goToPreviousPage = () => {
    setPage(page - 1);
  };

  function editDialogClose(action: EDialogAction) {
    setEditDialogVisibility(false);
    if (action == EDialogAction.edit) {
    } else if (action == EDialogAction.view) {
    } else if (action == EDialogAction.delete) {
    }
    getCountryProcessList();
  }
  function alertDialogClose(action: EDialogAction) {
    setAlertDialogVisibility(false);
    getCountryProcessList();
  }
  function changeFilters(key: string, value: any) {
    setFilter((oldState: any) => {
      return { ...oldState, [key]: value };
    });
  }

  const naviagteToTemplates = (countryProcessId: any) => {
    navigate({
      pathname: "/admin/countryTemplate",
      search: `?countryProcessId=${countryProcessId}`,
    });
  };

  return (
    <>
      <CountryProcessDialogBox
        open={editDialogVisibility}
        onClose={editDialogClose}
        data={countryProcess}
        dialogAction={dialogAction}
      />
      <AlertDialog
        openAlert={alertDialogVisibility}
        onCloseAlert={alertDialogClose}
        data={countryProcess}
        action="countryProcess"
      />
      <Paper>
        <TableContainer component={Paper}>
          <Table aria-label="country process table">
            <TableHead>
              <TableRow>
                <TableCell>Id</TableCell>
                <TableCell>Country Name</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Start - End Dates</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!isLoading && countryProcessList.map((data: any) => (
                <TableRow key={data.id}>
                  <TableCell>{data.id}</TableCell>
                  <TableCell>
                    {data.country_name} - {data.country_code}
                  </TableCell>
                  <TableCell>{data.title}</TableCell>
                  <TableCell>
                    {data.status === "enb" ? <Chip label="Enabled" color="success" /> : <Chip label="Disabled" color="warning" />}
                  </TableCell>
                  <TableCell>
                    {data.type === 'dom' ? <Chip label="Domestic" /> : <Chip label="Corporate" />}
                  </TableCell>
                  <TableCell>
                    {data.start_date} -<br />
                    {data.end_date === null ? "" : data.end_date}
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={() => {
                        getCountryProcessById(data.id, EDialogAction.view);
                      }}
                    >
                      <OpenInNew />
                    </Button>{" "}
                    <Button
                      variant="contained"
                      color="secondary"
                      size="small"
                      onClick={() => {
                        getCountryProcessById(data.id, EDialogAction.edit);
                      }}
                    >
                      <EditOutlined />
                    </Button>{" "}

                    <Button
                      variant="contained"
                      color="secondary"
                      size="small"
                      endIcon={<SendOutlined />}
                      onClick={() => {
                        changeFilters("country_process_id", data.id);
                        naviagteToTemplates(data.id);
                      }}
                    >
                      Template
                    </Button>{" "}
                    <Button
                      variant="contained"
                      color="error"
                      size="small"
                      onClick={() => {
                        getCountryProcessById(data.id, EDialogAction.delete);
                      }}
                    >
                      <DeleteOutline />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
              {isLoading && (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              )}
              {!isLoading && countryProcessList.length == 0 && (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    No Data Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25,]}
            count={totalItems}
            rowsPerPage={limit}
            page={page}
            onPageChange={(event, newPage) => {
              setPage(newPage);
            }}
            onRowsPerPageChange={(event) => {
              setLimit(parseInt(event.target.value));
            }}
          />
          </Table>
        </TableContainer>
      </Paper>
      <div className="h-12"></div>
    </>
  );
};

export default CountryProcessTableTable;
